
  // Shim Vue HMR runtime for dev-compiled components loaded by a non-Vite host.
  // When a remote is served by a Vite dev server, Vue's SFC compiler injects HMR
  // hooks that reference __VUE_HMR_RUNTIME__. This global only exists on pages
  // served by Vite's client runtime. When a production host loads the remote,
  // the HMR calls would throw. This no-op shim prevents that.
  if (typeof __VUE_HMR_RUNTIME__ === 'undefined') {
    globalThis.__VUE_HMR_RUNTIME__ = { createRecord() {}, rerender() {}, reload() {} };
  }
  import {createInstance, loadRemote} from "@module-federation/runtime";
  
  
const __mfResolveGlobalKey = "__mf_init____mf__virtual/__mfe_internal__assembler__mf_v__runtimeInit__mf_v__.js__";
let __mfResolveState = globalThis[__mfResolveGlobalKey];
if (!__mfResolveState) {
  let initResolve, initReject;
  const initPromise = new Promise((re, rj) => {
    initResolve = re;
    initReject = rj;
  });
  __mfResolveState = globalThis[__mfResolveGlobalKey] = {
    initPromise,
    initResolve,
    initReject,
  };
  if (typeof window === 'undefined') {
    initResolve({
      loadRemote: function() { return Promise.resolve(undefined); },
      loadShare: function() { return Promise.resolve(undefined); },
    });
  }
}
const initResolve = __mfResolveState.initResolve;

  
const __mfCacheGlobalKey = "__mf_module_cache__";
globalThis[__mfCacheGlobalKey] ||= { share: {}, remote: {} };
globalThis[__mfCacheGlobalKey].share ||= {};
globalThis[__mfCacheGlobalKey].remote ||= {};
const __mfModuleCache = globalThis[__mfCacheGlobalKey];

  const initTokens = {}
  const shareScopeName = "default"
  const mfName = "__mfe_internal__assembler"
  let runtimeInstance
  let localSharedImportMapPromise
  let exposesMapPromise
  const shouldRetrySharedInitError = false && ((error) => {
    const message = String((error && error.message) || error || '');
    return message.includes('Importing a module script failed') ||
      message.includes('Failed to fetch') ||
      message.includes('Load failed') ||
      message.includes('Outdated Optimize Dep');
  });
  const waitSharedInitRetry = (ms) => new Promise((resolve) => setTimeout(resolve, ms));
  async function retrySharedInit(fn) {
    for (let attempt = 0; ; attempt++) {
      try {
        return await fn();
      } catch (e) {
        const canRetry = typeof shouldRetrySharedInitError === 'function' && shouldRetrySharedInitError(e);
        if (!canRetry || attempt >= 19) throw e;
        await waitSharedInitRetry(250);
      }
    }
  }

  async function getLocalSharedImportMap() {
    if (!localSharedImportMapPromise) {
      localSharedImportMapPromise = retrySharedInit(() => import("virtual:mf-localSharedImportMap:__mfe_internal__assembler"))
        .catch((e) => { localSharedImportMapPromise = undefined; throw e; });
    }
    return localSharedImportMapPromise
  }

  async function getExposesMap() {
    if (!exposesMapPromise) {
      exposesMapPromise = retrySharedInit(() => import("virtual:mf-exposes:__mfe_internal__assembler__remoteEntry_js"))
        .then((mod) => mod.default ?? mod)
        .catch((e) => { exposesMapPromise = undefined; throw e; });
    }
    return exposesMapPromise
  }

  async function init(shared = {}, initScope = []) {
    const {usedShared, usedRemotes} = await getLocalSharedImportMap()
    if (__mfModuleCache.share["react"] === undefined) {
        const mod = await import("/workspace/output/node_modules/.pnpm/react@19.2.5/node_modules/react/index.js");
        const exportModule = false && "react" === "react"
          ? (mod?.default ?? mod)
          : {...mod};
        Object.defineProperty(exportModule, "__esModule", {
          value: true,
          enumerable: false
        });
        __mfModuleCache.share["react"] = exportModule;
      }
if (__mfModuleCache.share["react-dom"] === undefined) {
        const mod = await import("/workspace/output/node_modules/.pnpm/react-dom@19.2.5_react@19.2.5/node_modules/react-dom/index.js");
        const exportModule = false && "react-dom" === "react"
          ? (mod?.default ?? mod)
          : {...mod};
        Object.defineProperty(exportModule, "__esModule", {
          value: true,
          enumerable: false
        });
        __mfModuleCache.share["react-dom"] = exportModule;
      }
if (__mfModuleCache.share["react/jsx-runtime"] === undefined) {
        const mod = await import("/workspace/output/node_modules/.pnpm/react@19.2.5/node_modules/react/jsx-runtime.js");
        const exportModule = false && "react/jsx-runtime" === "react"
          ? (mod?.default ?? mod)
          : {...mod};
        Object.defineProperty(exportModule, "__esModule", {
          value: true,
          enumerable: false
        });
        __mfModuleCache.share["react/jsx-runtime"] = exportModule;
      }
if (__mfModuleCache.share["@azure/msal-browser"] === undefined) {
        const mod = await import("/workspace/output/node_modules/.pnpm/@azure+msal-browser@4.30.0/node_modules/@azure/msal-browser/dist/index.mjs");
        const exportModule = false && "@azure/msal-browser" === "react"
          ? (mod?.default ?? mod)
          : {...mod};
        Object.defineProperty(exportModule, "__esModule", {
          value: true,
          enumerable: false
        });
        __mfModuleCache.share["@azure/msal-browser"] = exportModule;
      }
if (__mfModuleCache.share["@azure/msal-react"] === undefined) {
        const mod = await import("/workspace/output/node_modules/.pnpm/@azure+msal-react@3.0.29_@azure+msal-browser@4.30.0_react@19.2.5/node_modules/@azure/msal-react/dist/index.js");
        const exportModule = false && "@azure/msal-react" === "react"
          ? (mod?.default ?? mod)
          : {...mod};
        Object.defineProperty(exportModule, "__esModule", {
          value: true,
          enumerable: false
        });
        __mfModuleCache.share["@azure/msal-react"] = exportModule;
      }
if (__mfModuleCache.share["@ford-mstech/ui-ford-ui-components"] === undefined) {
        const mod = await import("/workspace/output/node_modules/.pnpm/@ford-mstech+ui-ford-ui-components@0.9.16_3f72f44cfbbabf0c623ccfdbf4893613/node_modules/@ford-mstech/ui-ford-ui-components/index.js");
        const exportModule = false && "@ford-mstech/ui-ford-ui-components" === "react"
          ? (mod?.default ?? mod)
          : {...mod};
        Object.defineProperty(exportModule, "__esModule", {
          value: true,
          enumerable: false
        });
        __mfModuleCache.share["@ford-mstech/ui-ford-ui-components"] = exportModule;
      }
if (__mfModuleCache.share["@tanstack/react-query"] === undefined) {
        const mod = await import("/workspace/output/node_modules/.pnpm/@tanstack+react-query@5.100.9_react@19.2.5/node_modules/@tanstack/react-query/build/modern/index.js");
        const exportModule = false && "@tanstack/react-query" === "react"
          ? (mod?.default ?? mod)
          : {...mod};
        Object.defineProperty(exportModule, "__esModule", {
          value: true,
          enumerable: false
        });
        __mfModuleCache.share["@tanstack/react-query"] = exportModule;
      }
if (__mfModuleCache.share["@tanstack/react-router"] === undefined) {
        const mod = await import("/workspace/output/node_modules/.pnpm/@tanstack+react-router@1.169.2_react-dom@19.2.5_react@19.2.5__react@19.2.5/node_modules/@tanstack/react-router/dist/esm/index.js");
        const exportModule = false && "@tanstack/react-router" === "react"
          ? (mod?.default ?? mod)
          : {...mod};
        Object.defineProperty(exportModule, "__esModule", {
          value: true,
          enumerable: false
        });
        __mfModuleCache.share["@tanstack/react-router"] = exportModule;
      }
if (__mfModuleCache.share["i18next"] === undefined) {
        const mod = await import("/workspace/output/node_modules/.pnpm/i18next@25.10.10_typescript@6.0.3/node_modules/i18next/dist/esm/i18next.js");
        const exportModule = false && "i18next" === "react"
          ? (mod?.default ?? mod)
          : {...mod};
        Object.defineProperty(exportModule, "__esModule", {
          value: true,
          enumerable: false
        });
        __mfModuleCache.share["i18next"] = exportModule;
      }
if (__mfModuleCache.share["react-dom/client"] === undefined) {
        const mod = await import("/workspace/output/node_modules/.pnpm/react-dom@19.2.5_react@19.2.5/node_modules/react-dom/client.js");
        const exportModule = false && "react-dom/client" === "react"
          ? (mod?.default ?? mod)
          : {...mod};
        Object.defineProperty(exportModule, "__esModule", {
          value: true,
          enumerable: false
        });
        __mfModuleCache.share["react-dom/client"] = exportModule;
      }
if (__mfModuleCache.share["react-i18next"] === undefined) {
        const mod = await import("/workspace/output/node_modules/.pnpm/react-i18next@16.6.6_i18next@25.10.10_typescript@6.0.3__react-dom@19.2.5_react@19.2.5__react@19.2.5_typescript@6.0.3/node_modules/react-i18next/dist/es/index.js");
        const exportModule = false && "react-i18next" === "react"
          ? (mod?.default ?? mod)
          : {...mod};
        Object.defineProperty(exportModule, "__esModule", {
          value: true,
          enumerable: false
        });
        __mfModuleCache.share["react-i18next"] = exportModule;
      }
if (__mfModuleCache.share["react-router-dom"] === undefined) {
        const mod = await import("/workspace/output/node_modules/.pnpm/react-router-dom@7.15.0_react-dom@19.2.5_react@19.2.5__react@19.2.5/node_modules/react-router-dom/dist/index.mjs");
        const exportModule = false && "react-router-dom" === "react"
          ? (mod?.default ?? mod)
          : {...mod};
        Object.defineProperty(exportModule, "__esModule", {
          value: true,
          enumerable: false
        });
        __mfModuleCache.share["react-router-dom"] = exportModule;
      }
if (__mfModuleCache.share["zustand"] === undefined) {
        const mod = await import("/workspace/output/node_modules/.pnpm/zustand@5.0.13_@types+react@19.2.14_react@19.2.5_use-sync-external-store@1.6.0_react@19.2.5_/node_modules/zustand/esm/index.mjs");
        const exportModule = false && "zustand" === "react"
          ? (mod?.default ?? mod)
          : {...mod};
        Object.defineProperty(exportModule, "__esModule", {
          value: true,
          enumerable: false
        });
        __mfModuleCache.share["zustand"] = exportModule;
      }
if (__mfModuleCache.share["zustand/react"] === undefined) {
        const mod = await import("/workspace/output/node_modules/.pnpm/zustand@5.0.13_@types+react@19.2.14_react@19.2.5_use-sync-external-store@1.6.0_react@19.2.5_/node_modules/zustand/react.js");
        const exportModule = false && "zustand/react" === "react"
          ? (mod?.default ?? mod)
          : {...mod};
        Object.defineProperty(exportModule, "__esModule", {
          value: true,
          enumerable: false
        });
        __mfModuleCache.share["zustand/react"] = exportModule;
      }
if (__mfModuleCache.share["zustand/vanilla"] === undefined) {
        const mod = await import("/workspace/output/node_modules/.pnpm/zustand@5.0.13_@types+react@19.2.14_react@19.2.5_use-sync-external-store@1.6.0_react@19.2.5_/node_modules/zustand/vanilla.js");
        const exportModule = false && "zustand/vanilla" === "react"
          ? (mod?.default ?? mod)
          : {...mod};
        Object.defineProperty(exportModule, "__esModule", {
          value: true,
          enumerable: false
        });
        __mfModuleCache.share["zustand/vanilla"] = exportModule;
      }
    const runtimeOptions = {
      name: mfName,
      remotes: usedRemotes,
      shared: usedShared,
      plugins: [],
      shareStrategy: 'version-first'
    };
    if (!runtimeInstance) {
      runtimeInstance = createInstance(runtimeOptions);
    } else {
      runtimeInstance.initOptions(runtimeOptions);
    }
    const initRes = runtimeInstance;
    // handling circular init calls
    var initToken = initTokens[shareScopeName];
    if (!initToken)
      initToken = initTokens[shareScopeName] = { from: mfName };
    if (initScope.indexOf(initToken) >= 0) return;
    initScope.push(initToken);
    initRes.initShareScopeMap('default', shared);
    initResolve(initRes)
    try {
      await retrySharedInit(async () => {
        await Promise.all(await initRes.initializeSharing('default', {
          strategy: 'version-first',
          from: "build",
          initScope
        }));
      });
    } catch (e) {
      console.error('[Module Federation]', e)
    }
    return initRes
  }

  async function getExposes(moduleName) {
    const exposesMap = await getExposesMap()
    if (!(moduleName in exposesMap)) throw new Error(`[Module Federation] Module ${moduleName} does not exist in container.`)
    return (exposesMap[moduleName])().then(res => () => res)
  }
  export {
      init,
      getExposes as get
  }
  